import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-yes-no-cancel-message',
  imports: [MatButtonModule, AsyncPipe],
  templateUrl: './yes-no-cancel-message.component.html',
  styleUrl: './yes-no-cancel-message.component.scss'
})
export class YesNoCancelMessageComponent {
  result: 'yes' | 'no' | 'cancel' = 'cancel';

  constructor(
    private matSnackBarRef: MatSnackBarRef<YesNoCancelMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      message: Observable<string>,
      yesLabel: Observable<string>,
      noLabel: Observable<string>,
      cancelLabel: Observable<string>
    }) {
  }

  protected yes(): void {
    this.result = 'yes';
    this.dismiss();
  }

  protected no(): void {
    this.result = 'no';
    this.dismiss();
  }

  protected cancel(): void {
    this.result = 'cancel';
    this.dismiss();
  }

  private dismiss(): void {
    this.matSnackBarRef.dismiss();
  }
}
